import type { DiffChange } from 'types';

export function computeDiff(oldText: string, newText: string): DiffChange[] {
    const oldLines = oldText.split('\n');
    const newLines = newText.split('\n');
    const changes: DiffChange[] = [];

    let i = 0;
    let j = 0;

    while (i < oldLines.length || j < newLines.length) {
        if (i >= oldLines.length) {
            changes.push({ type: 'added', value: newLines[j] });
            j++;
        } else if (j >= newLines.length) {
            changes.push({ type: 'removed', value: oldLines[i] });
            i++;
        } else if (oldLines[i] === newLines[j]) {
            changes.push({ type: 'unchanged', value: oldLines[i] });
            i++;
            j++;
        } else {
            const oldInNew = newLines.slice(j).indexOf(oldLines[i]);
            const newInOld = oldLines.slice(i).indexOf(newLines[j]);

            if (oldInNew !== -1 && (newInOld === -1 || oldInNew < newInOld)) {
                for (let k = 0; k < oldInNew; k++) {
                    changes.push({ type: 'added', value: newLines[j + k] });
                }
                j += oldInNew;
            } else if (newInOld !== -1) {
                for (let k = 0; k < newInOld; k++) {
                    changes.push({ type: 'removed', value: oldLines[i + k] });
                }
                i += newInOld;
            } else {
                changes.push({ type: 'removed', value: oldLines[i] });
                changes.push({ type: 'added', value: newLines[j] });
                i++;
                j++;
            }
        }
    }

    return changes;
}

export function formatRelativeTime(timestamp: number): string {
    const now = Date.now();
    const diff = now - timestamp;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) return `${years} year${years > 1 ? 's' : ''} ago`;
    if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return 'Just now';
}
